module.exports = __webpack_public_path__ + "img/certificate02-2-1.56f5cb5f.jpg";